import React, { useEffect, useState} from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css";
import {BASE_URL} from "./Constants";

const Navbar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  // ---------------- Fetch logged-in user ----------------
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(`${BASE_URL}/get_user_details`, {
          method: "GET",
          credentials: "include",
        });
        if (!res.ok) throw new Error("Not logged in");
        const data = await res.json();
        setUser(data);
      } catch {
        setUser(null);
      }
    };
    fetchUser();
  }, []);

  // ---------------- Profile click handler ----------------
  const handleProfileClick = () => {
    if (user) {
      navigate("/myaccount");
    } else {
      navigate("/checkout/login"); // or "/login"
    }
  };

  return (
    <nav className="nav-bar">
      <div className="navbar-left">
        <img src="/assets/logo_1.png" alt="Company Logo" className="company-logo" />
        <div className="hamburger" onClick={toggleMenu}>☰</div>
        <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
          <li><Link to="/" onClick={toggleMenu}>Item</Link></li>
        </ul>
      </div>

      <div className="navbar-right">
        {/* PROFILE ICON – NO DROPDOWN */}
        <div className="nav-icons profile-icon" onClick={handleProfileClick}>
          <img src="/assets/profile.png" alt="Profile" className="icon-image" />
          <span>{user ? "Profile" : "Login"}</span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;


